import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FiUsers } from 'react-icons/fi';
import AllHolders from './AllHolders';
import HolderDetail from './HolderDetail';

// url segment → tab; no segment = All holders. Top holders / Holdings movement / Reports land here as they are built.
const tabs = [
    { path: '', label: 'All holders', icon: <FiUsers />, component: AllHolders },
];

const ShareRegistry: React.FC = () => {
    const history = useHistory();
    const { tab = '', id } = useParams<{ tab?: string; id?: string }>();
    // /share-registry/holder/{holderId} (or /holder/web?email=) opens a holder under the All holders tab
    const holder = tab === 'holder';
    const current = tabs.find(x => x.path === tab) ?? tabs[0];

    return <div className="v2-page share-registry-v2">
        <div className="sub-tabs">
            {tabs.map(x => <button key={x.path} type="button" className={x === current ? 'active' : ''}
                onClick={() => history.push(`/share-registry${x.path && `/${x.path}`}`)}>{x.icon} {x.label}</button>)}
        </div>

        {/* each tab renders its own .page-header — subtitle and actions differ per tab */}
        {holder ? <HolderDetail key={id} holderId={id} /> : <current.component />}
    </div>;
};

export default ShareRegistry;
